var $bc5bf91d2223a2c1$exports = {};
$bc5bf91d2223a2c1$exports = {
    "(optional)": `(opcjonalne)`,
    "(required)": `(wymagane)`
};


export {$bc5bf91d2223a2c1$exports as default};
//# sourceMappingURL=pl-PL.mjs.map
